import StudentPanelsConfig from '../../student-container/student-panels.config';

const BasicInfoConfig = {
  title: StudentPanelsConfig.BASIC_INFO.human,
  paths: [
    'student.studentDetails.admitDate',
    'student.studentDetails.dob',
    'student.studentDetails.classOf',
    'student.studentDetails.currGradeLevel',
    'student.studentDetails.counselor',
    'student.schoolStatus',
    'student.ellDetails.isEll',
    'student.spedDetails.isSped',
    'student.assmnts.schoolRiskGroup',
    'schoolUsers.preferredName',
    'schoolUsers.name.firstName',
    'schoolUsers.name.lastName',
  ],
};

export default BasicInfoConfig;
